
import { UseFormRegister, UseFormWatch, UseFormSetValue } from 'react-hook-form';
import { MedicalCarrierInformation } from '@/components/application/entity/MedicalCarrierInformation';
import { WorkersCompInformation } from '@/components/application/entity/WorkersCompInformation';
import { AncillaryCarrierInformation } from '@/components/application/entity/AncillaryCarrierInformation';
import { HealthPlans } from '@/components/application/insurance/HealthPlans';
import { MedicalEnrollmentInfo } from '@/components/application/insurance/MedicalEnrollmentInfo';
import type { Application } from '@/types/database.types';

interface CarrierInformationProps {
  register: UseFormRegister<Partial<Application>>;
  watch: UseFormWatch<Partial<Application>>;
  setValue: UseFormSetValue<Partial<Application>>;
  data: Partial<Application>;
}

export const CarrierInformation = ({ register, watch, setValue, data }: CarrierInformationProps) => {
  // Ensure data is present before processing
  const processedData = data || {};

  return (
    <div className="space-y-10">
      <div>
        <h3 className="text-lg font-semibold mb-4">Medical Insurance</h3>
        <MedicalCarrierInformation
          register={register}
          watch={watch}
          setValue={setValue}
          data={processedData}
        />
      </div>

      {/* Health Plans section moved here */}
      <div>
        <HealthPlans
          register={register}
          watch={watch}
          setValue={setValue}
          data={processedData}
        />
      </div>
      
      {/* Enrollment Information section moved here */}
      <div>
        <MedicalEnrollmentInfo
          register={register}
          watch={watch}
          setValue={setValue}
          data={processedData}
        />
      </div>

      <div>
        <h3 className="text-lg font-semibold mb-4">Workers' Compensation</h3>
        <WorkersCompInformation
          register={register}
          watch={watch}
          setValue={setValue}
          data={processedData}
        />
      </div>

      <div>
        <h3 className="text-lg font-semibold mb-4">Ancillary Benefits</h3>
        <AncillaryCarrierInformation
          register={register}
          watch={watch}
          setValue={setValue}
          data={processedData}
        />
      </div>
    </div>
  );
};
